import type { ComponentProps } from 'react';
import { Gutter } from './Gutter';
import { Notice } from './Notice';
import { Section } from './Section';

/**
 * Плашка ОТДЕЛЬНЫМ блоком ленты экрана, а не внутри карточки.
 *
 * Своих полей у `Notice` нет, и это верно: внутри карточки они были бы
 * лишними. Но в лентах экранов проверки десять плашек стояли голыми детьми —
 * без полей по бокам и без шва сверху: они дотягивались до самых краёв
 * экрана и прилипали к соседу сверху. Владельцы у них те же, что у всего
 * остального на экране, — раздел даёт шов, коробка даёт поле.
 */
export function NoticeBlock(props: ComponentProps<typeof Notice>) {
  return (
    <Section>
      <Gutter>
        <Notice {...props} />
      </Gutter>
    </Section>
  );
}
